import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const Prequal = ({ service }) => {
  const handlechange = (value) => {};
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", p: "8px 8px 8px 24px" }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="Agility Credit"
          name="radio-buttons-group"
        >
          <FormControlLabel
            value="Agility Credit"
            control={<Radio />}
            label="Agility Credit"
            checked={true}
            disabled={true}
          />
        </RadioGroup>
        {/* <Switch
          checked={service?.provider_id ? true : false}
          size="small"
          onChange={(e) => handlechange(e.target.checked)}
          disabled={true}
        /> */}
        {/* <Typography variant="body1">PreQualification</Typography> */}
      </Box>
    </Box>
  );
};

export default Prequal;
